import { atom } from "recoil";

export const qrCodeValuesAtom = atom({
  key: "qrCodeValuesAtom",
  default: "",
});
